<template>
  <div v-if="showSection">
    <v-subheader class="px-0">{{ $t("STOCK.TRANSPORT_ORDERS.MODE_DATA") }}</v-subheader>
    <v-row>
      <v-col
        v-for="field in activeFields"
        :key="field.key"
        cols="12"
        :md="field.cols || 4"
      >
        <v-text-field
          v-if="field.type !== 'date'"
          :value="localValue[field.key]"
          :label="$t(field.labelKey)"
          :disabled="disabled"
          @input="updateField(field.key, $event)"
        ></v-text-field>
        <DatePicker
          v-else
          :value="localValue[field.key]"
          :label="$t(field.labelKey)"
          :disabled="disabled"
          without-hint
          @input="updateField(field.key, $event)"
        ></DatePicker>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import DatePicker from "@/views/partials/form/DatePicker.vue";

const MODE_FIELDS = {
  container_sea: [
    { key: "container_no", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.CONTAINER_NO" },
    { key: "vessel_name", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.VESSEL_NAME" },
    { key: "bill_of_lading_no", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.BILL_OF_LADING_NO" },
    { key: "port_of_loading", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.PORT_OF_LOADING" },
    { key: "port_of_discharge", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.PORT_OF_DISCHARGE" },
    { key: "eta_port", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.ETA_PORT", type: "date" },
  ],
  container_road: [
    { key: "container_no", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.CONTAINER_NO" },
  ],
  air_cargo: [
    { key: "awb_number", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.AWB_NUMBER" },
    { key: "flight_number", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.FLIGHT_NUMBER" },
    { key: "airport_origin", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.AIRPORT_ORIGIN" },
    { key: "airport_destination", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.AIRPORT_DESTINATION" },
  ],
  rail: [
    { key: "wagon_number", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.WAGON_NUMBER" },
    { key: "train_number", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.TRAIN_NUMBER" },
  ],
  multimodal: [
    { key: "legs_description", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.LEGS_DESCRIPTION", cols: 12 },
  ],
  other: [
    { key: "details", labelKey: "STOCK.TRANSPORT_ORDERS.MODE.DETAILS", cols: 12 },
  ],
};

export default {
  name: "StockTransportModeFields",
  components: { DatePicker },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    transportMode: {
      type: String,
      default: "road",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue() {
      const value = this.value;
      if (value && typeof value === "object" && !Array.isArray(value)) {
        return value;
      }
      return {};
    },
    activeFields() {
      return MODE_FIELDS[this.transportMode] || [];
    },
    showSection() {
      return this.activeFields.length > 0;
    },
  },
  methods: {
    updateField(key, value) {
      this.$emit("input", {
        ...this.localValue,
        [key]: value,
      });
    },
  },
};
</script>
